export default "__VITE_ASSET__C9T0BbQI__"